import { cva } from 'class-variance-authority'

export const labelTextVariants = cva(
  'text-primary flex items-center gap-2 truncate',
  {
    variants: {
      size: {
        small: 'min-h-5 text-sm font-medium leading-5',
        base: 'min-h-6 text-base font-medium leading-6',
      },
    },
    defaultVariants: {
      size: 'base',
    },
  },
)

// The label sizes to its content (see `shrink` below) and the value takes the
// remaining space. When a value is present, `min-w-20` is applied at the call
// site so a short value is never crushed to a sliver by a long label — the
// label truncates instead. The floor is omitted when the value is empty so a
// long label can use the full width.
export const valueTextVariants = cva(
  'flex min-w-0 flex-1 items-start justify-end gap-2 text-primary text-right break-words',
  {
    variants: {
      size: {
        small: 'min-h-5 text-sm leading-5',
        base: 'min-h-6 text-base leading-6',
      },
    },
    defaultVariants: {
      size: 'base',
    },
  },
)

export const iconVariants = cva(
  'flex items-center justify-center text-primary py-0.5 [&>svg]:stroke-2',
  {
    variants: {
      size: {
        small: '[&>svg]:size-4',
        base: '[&>svg]:size-5',
      },
    },
    defaultVariants: {
      size: 'base',
    },
  },
)

export const childrenTextVariants = cva('flex flex-col gap-2 text-secondary', {
  variants: {
    size: {
      small: 'text-sm leading-5',
      base: 'text-base leading-6',
    },
    hasIcon: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      hasIcon: true,
      size: 'small',
      class: 'pl-6',
    },
    {
      hasIcon: true,
      size: 'base',
      class: 'pl-7',
    },
  ],
  defaultVariants: {
    size: 'base',
    hasIcon: false,
  },
})

export const descriptionTextVariants = cva(
  'text-sm leading-5 text-left text-secondary',
  {
    variants: {
      size: {
        small: '',
        base: '',
      },
      hasIcon: {
        true: '',
        false: '',
      },
    },
    compoundVariants: [
      {
        hasIcon: true,
        size: 'small',
        class: 'pl-6',
      },
      {
        hasIcon: true,
        size: 'base',
        class: 'pl-7',
      },
    ],
    defaultVariants: {
      size: 'base',
      hasIcon: false,
    },
  },
)
